import { render, staticRenderFns } from "./FakFreightSectionSettingPop.vue?vue&type=template&id=3b03a210"
import script from "./FakFreightSectionSettingPop.vue?vue&type=script&lang=js"
export * from "./FakFreightSectionSettingPop.vue?vue&type=script&lang=js"
import style0 from "./FakFreightSectionSettingPop.vue?vue&type=style&index=0&id=3b03a210&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b03a210')) {
      api.createRecord('3b03a210', component.options)
    } else {
      api.reload('3b03a210', component.options)
    }
    module.hot.accept("./FakFreightSectionSettingPop.vue?vue&type=template&id=3b03a210", function () {
      api.rerender('3b03a210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/popup/FakFreightSectionSettingPop.vue"
export default component.exports